export default "__VITE_ASSET__BC9wX2Eh__"